import {Row, Col} from 'antd';
import {useEffect, useState} from 'react';
import {FaPlus} from 'react-icons/fa';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import Button from '../../../../../../shared/components/button';
import {specificationAttributeService} from '../../../../../../shared/services/specification-attribute';
import {AttributesOptionListDto} from '../../../../../../shared/services/specification-attribute/dto/attributes-option-dto';
import AttributesOptionTable from './attributes-option-table';
import OptionModal from './option-modal';

interface IAttributeOptionsProps {}

const AttributeOptions = (props: IAttributeOptionsProps) => {
  const {messages} = useIntl();

  const {id} = useParams();

  const [addOptionModalVisbility, setAddOptionModalVisbility] = useState(false);

  const [attributesOption, setAttributesOption] = useState<
    AttributesOptionListDto[]
  >([]);

  const [isAttributesOptionLoading, setIsAttributesOptionLoading] =
    useState(false);

  const [attributeOptionDetails, setAttributeOptionDetails] =
    useState<AttributesOptionListDto>();

  useEffect(() => {
    if (id) {
      (async () => {
        setIsAttributesOptionLoading(true);
        try {
          let attributesOptionObj =
            await specificationAttributeService.getOptionsBySpecificationAttributeId(
              id,
            );
          setAttributesOption(attributesOptionObj?.options);
        } catch (error) {
          console.error(error);
        } finally {
          setIsAttributesOptionLoading(false);
        }
      })();
    }
  }, [id]);

  const getAttributesOptionsAll = async () => {
    if (id) {
      (async () => {
        setIsAttributesOptionLoading(true);
        try {
          let attributesOptionObj =
            await specificationAttributeService.getOptionsBySpecificationAttributeId(
              id,
            );
          setAttributesOption(attributesOptionObj?.options);
        } catch (error) {
          console.error(error);
        } finally {
          setIsAttributesOptionLoading(false);
        }
      })();
    }
  };

  const editAttributeOptionModal = (item: AttributesOptionListDto) => {
    setAddOptionModalVisbility(true);
    setAttributeOptionDetails(item);
  };

  const openOptionModal = () => {
    setAddOptionModalVisbility(true);
    setAttributeOptionDetails(undefined);
  };

  const onCancelModal = () => {
    setAddOptionModalVisbility(false);
  };

  const onFinishModal = async () => {
    setAddOptionModalVisbility(false);
    await getAttributesOptionsAll();
  };

  const renderAddOptionModal = () => {
    return (
      <OptionModal
        visible={addOptionModalVisbility}
        attributeOptionDetails={attributeOptionDetails}
        onCancel={onCancelModal}
        onFinish={onFinishModal}
      />
    );
  };

  return (
    <Row gutter={[0, 20]}>
      <Col span={24}>
        <Row justify='end'>
          <Col>
            <Button
              icon={<FaPlus className='add-button-icon' />}
              onClickAction={openOptionModal}
              type='primary'
              text={messages[
                'specificationAttributes.edit.addNewOption'
              ].toString()}
              size='small'
              className='add-button'
            />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <AttributesOptionTable
          attributesOption={attributesOption}
          isAttributesOptionLoading={isAttributesOptionLoading}
          onEditAttributeOption={(item: AttributesOptionListDto) =>
            editAttributeOptionModal(item)
          }
          onFinish={getAttributesOptionsAll}
        />
      </Col>

      {renderAddOptionModal()}
    </Row>
  );
};

export default AttributeOptions;
